import React from 'react';

const AlertComponent = ({ type, message, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-bold mb-4">
          {type === 'logout' ? 'Cerrar Sesión' : 'Eliminar'}
        </h2>
        <p className="mb-4">{message}</p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="bg-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-400 transition-all"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className={`${
              type === 'logout' ? 'bg-red-500' : 'bg-blue-500'
            } text-white py-2 px-4 rounded-lg hover:${
              type === 'logout' ? 'bg-red-600' : 'bg-blue-600'
            } transition-all`}
          >
            {type === 'logout' ? 'Cerrar Sesión' : 'Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertComponent;